var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoData = function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".no-data_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1 1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1ZM7.5 13V2.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v12M3.5 14.5v-10a1 1 0 0 1 1-1h1M12.496 5.5H17.5M10.5 8.5h7M10.5 11.5h7",
    className: "no-data_svg__a"
  })));
};
export default SvgNoData;